import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SigninUpToggleComponent } from './signin-up-toggle/signin-up-toggle.component'
import { RouterModule } from '@angular/router'

@NgModule({
  declarations: [SigninUpToggleComponent],
  imports: [CommonModule, RouterModule],
  exports: [SigninUpToggleComponent],
})
export class SigninUpToggleModule {}
